import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner, Row, Col, Label, Input } from 'reactstrap';
import { motion } from 'framer-motion';
import FeatherIcon from 'feather-icons-react';
import api from '../helpers/api';

const AssignTechnicianModal = ({
  isOpen,
  toggle,
  ticketId,
  onAssign,
  isPendingStatus,
}) => {
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTechnician, setSelectedTechnician] = useState('');
  const [assigning, setAssigning] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchTechnicians();
    }
  }, [isOpen]);

  const fetchTechnicians = async () => {
    try {
      setLoading(true);
      // Uses RBAC user_roles table via user/technicians endpoint
      const { data } = await api.get('user/technicians');
      setTechnicians(data.response || []);
    } catch (error) {
      console.error('Error fetching technicians:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAssign = async () => {
    if (!selectedTechnician) return;
    
    try {
      setAssigning(true);
      await onAssign(ticketId,selectedTechnician);
    } finally {
      setAssigning(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.2 }}
      >
        <div className="modal-header">
          <h5 className="modal-title">
            <FeatherIcon icon="user-plus" className="me-2" />
            {isPendingStatus ? 'Assign Technician & Set to Pending' : 'Assign Technician'}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={toggle}
            aria-label="Close"
          />
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="text-center py-4">
              <Spinner color="primary" />
              <p className="mt-2">Loading technicians...</p>
            </div>
          ) : (
            <>
              <Row className="mb-3">
                <Col md={12}>
                  <Label for="technicianSelect">Select Technician</Label>
                  <Input
                    id="technicianSelect"
                    type="select"
                    value={selectedTechnician}
                    onChange={(e) => setSelectedTechnician(e.target.value)}
                  >
                    <option value="">Select a technician</option>
                    {technicians.map((tech) => (
                      <option key={tech.id} value={tech.id}>
                        {tech.name}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
              {isPendingStatus && (
                <div className="alert alert-info">
                  <FeatherIcon icon="info" className="me-2" />
                  The ticket status will be changed to "Pending" when you assign a technician.
                </div>
              )}
            </>
          )}
        </div>
        <div className="modal-footer">
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleAssign}
            disabled={!selectedTechnician || assigning}
          >
            {assigning ? (
              <>
                <Spinner size="sm" className="me-2" />
                Assigning...
              </>
            ) : (
              'Assign Technician'
            )}
          </Button>
        </div>
      </motion.div>
    </Modal>
  );
};

export default AssignTechnicianModal;